import { render, staticRenderFns } from "./NewLatestQuotedDocumentEditor.vue?vue&type=template&id=04828015&scoped=true&"
import script from "./NewLatestQuotedDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./NewLatestQuotedDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NewLatestQuotedDocumentEditor.vue?vue&type=style&index=0&id=04828015&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04828015",
  null
  
)

export default component.exports